module.exports = __webpack_public_path__ + "static/media/bg_home.6d0f234a.png";